import { useNavigate } from 'react-router-dom'

import singleCoin from 'src/shared/assets/images/single-coin.png'
import { PointIcon } from 'src/shared/components/icons/point-icon'

import type { CreditStatusInvite } from '../api/use-get-credit-status'
import { AddUser } from '../assets/add-user'

const InviteStatusIcon = ({
  type,
  invite,
}: {
  type: 'user' | 'invite' | 'reward'
  invite: CreditStatusInvite | null
}) => {
  const navigate = useNavigate()

  if (type === 'user') {
    return (
      <button
        className="relative flex size-[60px] items-center justify-center rounded-full border-0 bg-white"
        onClick={() => (typeof invite?.userId === 'string' ? navigate(`/referrals/users/${invite.userId}`) : null)}
      >
        {invite?.profilePhoto ? (
          <img src={invite.profilePhoto} alt="Profile" className="size-[60px] rounded-full object-cover" />
        ) : (
          <div className="flex size-[60px] items-center justify-center rounded-full bg-gray-200">
            <span className="text-lg font-bold text-gray-500">
              {invite?.invitedEmail?.charAt(0)?.toUpperCase() || '?'}
            </span>
          </div>
        )}
        <div
          className="absolute bottom-[-9px] flex flex-row items-center gap-1 rounded border-[0.5px] border-white bg-[#1E293B] px-1 py-0.5"
          style={{ borderColor: '#00FF85' }}
        >
          <span className="text-[10px] font-extrabold text-white/75">+10</span>
          <PointIcon className="mb-0.5 size-[10px] text-white/75" />
        </div>
      </button>
    )
  } else if (type === 'invite') {
    return (
      <div className="relative flex size-[59px] items-center justify-center rounded-full border border-dashed border-gray-300 bg-[#3d4f49]">
        <AddUser className="ml-0.5 size-6 text-white/75" />
        <div className="absolute bottom-[-10px] flex flex-row items-center gap-1 rounded border-[0.5px] border-white bg-[#1E293B] px-1 py-0.5">
          <span className="text-[10px] font-extrabold text-white/75">+10</span>
          <PointIcon className="size-[10px] text-white/75" />
        </div>
      </div>
    )
  } else {
    return (
      <div className="relative flex size-[64px] items-center justify-center rounded-full border border-dashed border-[#00FF85] bg-[#214938]">
        <img src={singleCoin} alt="QLC Icon" className="size-[30px] object-contain" />
        <div className="absolute bottom-[-8px] flex flex-row items-center gap-1 rounded border-[0.5px] border-white bg-[#1E293B] px-1 py-0.5">
          <span className="text-[10px] font-extrabold text-white/75">+10</span>
          <PointIcon className="mb-0.5 size-[10px] text-white/75" />
        </div>
      </div>
    )
  }
}

export default InviteStatusIcon
